import React, { useEffect, useState } from 'react';

import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import { TopBarMain } from './css';
import request from '../../../../utils/request';

import Filter from './components/filter';
import Block from './components/block';

const Outlets = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState();

  const fetchData = async () => {
    try {
      const result = await request.get('/get-outletIds');

      if (result && result.status === 200) {
        setApiData(result.data.outletIds);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <div className='layout-container'>
      <DimpleDivider />
      {!apiData && <Spinner spinning label="Loading data..." />}
      {apiData && (
        <>
          <TopBarMain>
            <Filter
              filterString={filterString}
              setFilterString={setFilterString}
            />
          </TopBarMain>
          <DimpleDivider />
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
      </div>
    </>
  );
};

export default Outlets;
